// CORE BUNDLE - Critical functionality needed on all pages
// Keep this lightweight to minimize initial JS

import { CookieBanner } from "./components/cookieBanner";
import { AnnouncementBanner } from "./components/announcementBanner";

document.addEventListener("DOMContentLoaded", function () {
  // Initialize Cookie Banner
  const banner = document.querySelector("section.banner");
  if (banner) {
    const bannerEl = new CookieBanner(banner);
  }

  // Initialize Announcement Banner
  const announcementBanner = document.querySelector("section.announcement");
  if (announcementBanner) {
    const bannerEl = new AnnouncementBanner(announcementBanner);
  }

  // Navigation hover effects for submenus
  const childLinks = document.querySelectorAll(".sub-menu");
  childLinks.forEach((link) => {
    link.addEventListener("mouseover", (event) => {
      const parentElement = event.target.closest(".menu-item-has-children");
      if (parentElement) {
        parentElement.classList.add("hover");
      }
    });

    link.addEventListener("mouseout", (event) => {
      const parentElement = event.target.closest(".menu-item-has-children");
      if (parentElement) {
        parentElement.classList.remove("hover");
      }
    });
  });
});

// Header shadow on scroll - affects sticky navigation
window.addEventListener("scroll", () => {
  const header = document.querySelector(".navbar.fixed-top");
  if (window.scrollY > 10) {
    header.classList.add("navbar__shadow");
  } else {
    header.classList.remove("navbar__shadow");
  }
});

// Modal reveal from URL hash - shows the matching modal on load and on hash
// change; auto-hide only fires on initial load, matching prior behavior.
function initHashModal(hashName, autoHideMs) {
  function reveal(withAutoHide) {
    if (location.hash && location.hash.replace('#', '') === hashName) {
      const modalElem = document.getElementById(hashName);
      if (modalElem && typeof window.bootstrap !== 'undefined') {
        const modal = new window.bootstrap.Modal(modalElem);
        modal.show();
        if (withAutoHide && autoHideMs) {
          window.setTimeout(() => modal.hide(), autoHideMs);
        }
      }
    }
  }

  window.addEventListener('load', () => reveal(true));
  window.addEventListener('hashchange', () => reveal(false));
}

// Needed for email links to #salesModal
initHashModal('salesModal');

// Needed for email links to #referModal
initHashModal('referModal');

// Redirect after sent to Paychex Salesforce
initHashModal('sentModal', 60000);
initHashModal('sentReferModal', 60000);
